import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  LOCALE_ID,
  Inject,
} from '@angular/core';
import { AuthService } from '@schoolbelle/api/auth';

@Component({
  selector: 'app-translation-viewer',
  templateUrl: './translation-viewer.component.html',
  styleUrls: ['./translation-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TranslationViewerComponent implements OnInit {
  protected _content:{[lang:string]:string} = {};
  @Input() set content(v:string|{[lang:string]:string}) {
    if (typeof v === 'string') {
      this._content = {[this.lang]:v}
    } 
    else {
      this._content = v;
    } 
  }
  @Input() query:string;
  protected _lang:string = (this.auth.currentUser && this.auth.currentUser.lang) || this.locale_id.slice(0,2);
  @Input() set lang(v:string) {
    if (this._lang === v) return;
    this._lang = v;
    if (this.inited) this.cdRef.detectChanges();
  }
  get lang () {
    return this._lang;
  }
  get text ():string {
    if (this._content) return this._content && this._content[this.lang] ? this._content[this.lang] : this._content[Object.keys(this._content)[0]];
    else return '';
  }  
  constructor(
    protected auth:AuthService,
    protected cdRef:ChangeDetectorRef,
    @Inject(LOCALE_ID) protected locale_id:string, 
  ) {}
  inited:boolean = false;
  ngOnInit() {
    this.inited = true;
  }
}
